module.exports = __webpack_public_path__ + "static/media/love-drivelah-2.db8425a4.jpg";